module.exports = __webpack_public_path__ + "static/img/office_06.a6ce326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/office_06.png
// module id = C+1u
// module chunks = 0